var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_4109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_4109)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#E31D1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2441_4109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2441_4109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37493 3.8797C4.37261 3.82985 4.43567 3.80952 4.46366 3.85084C4.75482 4.28074 5.65566 5.54658 6.16823 5.54658C6.78564 5.54658 9.21041 2.82238 9.92711 3.26616C10.6438 3.70994 12.0949 8.34984 12.0949 8.34984L11.1493 9.93134L9.92711 9.04237L9.58887 6.07878C9.58887 6.07878 7.34361 7.57887 6.16823 6.99326L5.50749 7.31459C5.50749 7.31459 4.87119 5.63463 4.62062 5.1208C4.43745 4.74516 4.38818 4.16475 4.37493 3.8797Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75008 7.93018L4.90514 8.52246L5.06651 7.26798L4.38293 6.37956L5.32761 6.19653L5.75008 5.05518L6.17255 6.19653L7.11722 6.37956L6.43365 7.26798L6.59502 8.52246L5.75008 7.93018Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44269 3.31496C9.45093 3.17754 9.56478 3.07031 9.70245 3.07031C9.8523 3.07031 9.97119 3.19655 9.96222 3.34613L9.79291 6.16761C9.78466 6.30503 9.67081 6.41225 9.53315 6.41225C9.38329 6.41225 9.26441 6.28602 9.27338 6.13643L9.44269 3.31496Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1998 4.94243C18.2355 4.96852 18.2312 5.03086 18.1934 5.0396C17.8073 5.12886 16.4553 5.47993 16.1756 6.07684C15.8484 6.77496 16.2961 10.9603 15.6341 11.5356C14.972 12.1108 11.2519 11.2928 11.2519 11.2928L10.7471 9.38551L11.9602 8.47464L14.0891 9.60552C14.0891 9.60552 14.2892 6.38808 15.2845 5.36936L15.4012 4.39282C15.4012 4.39282 16.8069 4.56358 17.2665 4.55255C17.6109 4.54428 18.0176 4.80915 18.1998 4.94243Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7382 4.65419L14.8092 3.38493L15.5216 4.23216L16.4489 3.93002L16.0647 5.09518L16.5668 6.17771L15.617 6.05058L15 7.02176L14.7971 5.77803L13.9137 5.29573L14.7382 4.65419Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7544 10.7076C15.8843 10.8338 15.9289 11.0534 15.858 11.2177C15.7729 11.415 15.5597 11.4507 15.4073 11.2931L14.0803 9.91989C13.9803 9.81646 13.9388 9.64956 13.978 9.50898C14.0365 9.29952 14.2434 9.23941 14.3958 9.38757L15.7544 10.7076Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6122 20.1677C10.577 20.1961 10.5388 20.162 10.5519 20.1143C10.686 19.6279 11.1363 17.8854 10.8879 17.2627C10.5981 16.5358 7.65574 14.9602 7.61314 13.9081C7.57054 12.856 9.96189 8.9694 9.96189 8.9694L11.4531 9.34016L11.4382 11.1963L9.50388 13.086C9.50388 13.086 11.6831 14.9091 11.8471 16.5678L12.3689 17.2105C12.3689 17.2105 11.5552 18.7483 11.3325 19.2845C11.1656 19.6867 10.7897 20.0241 10.6122 20.1677Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.86 16.2092L13.6489 16.9259L12.7424 17.3249L12.475 18.5467L11.9103 17.5205L10.9562 17.559L11.5137 16.5258L11.1914 15.3277L12.1006 15.7154L12.8556 14.9365L12.86 16.2092Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00193 14.3221C7.82746 14.4114 7.6458 14.3137 7.602 14.1071L7.59676 14.0824C7.55559 13.8882 7.65191 13.6684 7.81557 13.583L9.19809 12.862C9.3447 12.7856 9.50185 12.8406 9.57305 12.9933L9.58864 13.0267C9.68281 13.2286 9.58911 13.5105 9.39479 13.6098L8.00193 14.3221Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82003 9.35779C9.73058 9.31611 9.6828 9.18328 9.71331 9.0611C9.74383 8.93892 9.88713 8.73484 9.97659 8.77652L11.2242 9.35779C11.2886 9.38778 11.3338 9.46698 11.3395 9.55956L11.451 11.3841C11.4589 11.5127 11.3184 11.6168 11.2242 11.6275C11.13 11.6383 11.0473 11.5427 11.0394 11.4141L10.9361 9.84502L9.82003 9.35779Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9892 8.40205C12.0638 8.32274 12.197 8.41466 12.255 8.51652C12.3131 8.61837 12.2997 8.76523 12.2251 8.84454L11.3609 10.0256C11.2863 10.1049 11.1186 9.95022 11.0606 9.84836C11.0025 9.74651 10.986 9.46905 11.0606 9.38974L11.9892 8.40205Z",
    fill: "#FECA00"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2441_4109)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2441_4109",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImp);
export default __webpack_public_path__ + "static/media/IMP.5de34680c7bea8a87c58777015d67e52.svg";
export { ForwardRef as ReactComponent };